// @file Composable to handle Tldraw errors
import environment from '@@/bits/environment'
import { captureException } from '@@/bits/error_tracker'
import { __ } from '@@/bits/intl'
import { SnackbarNotificationType, useGlobalSnackbarStore } from '@@/pinia/global_snackbar'
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

export const useTldrawError = createSharedComposable(() => {
  const globalSnackbarStore = useGlobalSnackbarStore()

  const hasError = ref(false)

  const showErrorSnackbar = ({ persist = false }: { persist?: boolean } = {}): void => {
    globalSnackbarStore.setSnackbar({
      message: __('Sorry, there was an unexpected error. Please refresh the page and try again.'),
      notificationType: SnackbarNotificationType.error,
      persist,
    })
  }

  const captureError = (error: Error): void => {
    hasError.value = true

    showErrorSnackbar({ persist: true })

    captureException(error, { tags: { isTldrawError: true } })
    if (environment !== 'production') {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  return {
    hasError,
    captureError,
    showErrorSnackbar,
  }
})
